import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { client, readItems } from '../lib/directus';

export default function PostsListPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchPosts() {
      try {
        const result = await client.request(
          readItems('posts', {
            fields: ['id', 'title', 'slug', 'date_created'],
            filter: { published: { _eq: true } },
            sort: ['-date_created'],
          })
        );
        setPosts(result);
      } catch (err) {
        console.error('Error fetching posts:', err);
        setError('Could not load posts. Make sure Directus is running and the posts collection exists.');
      } finally {
        setLoading(false);
      }
    }

    fetchPosts();
  }, []);

  return (
    <div className="min-h-screen bg-neutral-950 text-neutral-200">
      <div className="max-w-3xl mx-auto px-5 py-10">
        <h1 className="text-2xl font-bold text-neutral-50 mb-8">Posts</h1>

        {loading && <p className="text-neutral-400">Loading posts...</p>}

        {error && (
          <div className="bg-red-500/10 border border-red-500/25 text-red-400 px-4 py-3 rounded-lg text-sm">
            {error}
          </div>
        )}

        {!loading && !error && posts.length === 0 && (
          <p className="text-neutral-500">No published posts yet.</p>
        )}

        <div className="space-y-3">
          {posts.map((post) => (
            <Link
              key={post.id}
              to={`/posts/${post.id}`}
              className="block bg-neutral-900 border border-neutral-800 rounded-lg p-5 hover:border-neutral-700 transition-colors"
            >
              <h2 className="text-lg font-semibold text-neutral-50">{post.title}</h2>
              {post.date_created && (
                <p className="text-xs text-neutral-500 mt-1">
                  {new Date(post.date_created).toLocaleDateString()}
                </p>
              )}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
